export default "__VITE_ASSET__7hZcOhpr__"